module.exports = __webpack_public_path__ + "static/img/mang.193b0bbd.png";